import LogoutView from './LogoutView'
export { LogoutView }
